import { PAYROLL_STATUS } from './constants'

export default {
  getPayrollStatus(state) {
    return status => {
      return PAYROLL_STATUS[status ?? 'created']
    }
  },

  getShiftsByType(state) {
    return type => state.shifts[type] ?? {}
  },

  getActivePayrollId(state) {
    return state.activePayroll?.id ?? null
  },

  isPaidPayroll(state) {
    return state.activePayroll?.status === 'paid'
  },

  isCompletePayroll(state) {
    return state.activePayroll?.status === 'completed'
  },

  canSignPayrollAssociates(state) {
    return ['completed', 'verified_completed'].includes(state.activePayroll?.status)
  },

  isSignCompetedPayroll(state) {
    return state.activePayroll?.status === "sign_completed";
  },
  getScopePresets(state) {
    return state.scopePresets ?? [];
  },
  getPremiumPayRules(state) {
    return state.premiumPayRules ?? [];
  },
  getPayCodeMappings(state) {
    return state.payCodeMappings ?? {};
  },
};
